import React from 'react'

import Grid, { Col } from '../../../../../components/pdf/Grid'
import Image from '../../../../../components/pdf/Image'
import { Text } from '../../../../../components/presentation/Text'
import LineSeparator from '../../../../../packages/kiti/components/helpers/LineSeparator'
import { COLORS } from '@btime/constants'

const Header = () => (
  <>
    <Grid justify="space-around" align="center">
      <Col>
        <Image src="/pdfs/concept/logo-concept.png" maxWidth={150} ignoreFixedSize />
      </Col>
      <Col>
        <Text bold color="black">
          2L Locadora de Veículos Ltda.
        </Text>
        <Text color="black">35.015.925/0001-90</Text>
        <Text color="black" size="small">
          RUA PROFESSOR LEÔNIDAS FERREIRA DA COSTA, 151, PAROLIN, CURITIBA, PR - 80220-410
        </Text>
      </Col>
    </Grid>
    <LineSeparator weight={4} color={COLORS.light3} padding={4} />
  </>
)

export default Header
